import { useMemo } from 'react';

export function useOldSpecificationsFieldsView() {
  return useMemo(() => {
    const searchParams = new URLSearchParams(window.location.search);

    return searchParams.has('old');
  }, []);
}
